// Shared inline-style helper so admin theme colors.bg / colors.bg_image
// (see ThemeContext.jsx) apply to page-level containers without needing a
// fixed Tailwind bg-[#hex] class that would otherwise cover them.
export const bgWithImageStyle = (bgColor = "var(--lv-bg,#060A14)") => ({
  backgroundColor: bgColor,
  backgroundImage: "var(--lv-bg-image, none)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundAttachment: "fixed",
  backgroundRepeat: "no-repeat",
});

// Per-section color override (Admin → Aspetto → Colori sezioni). Empty/unset
// means "eredita il colore sfondo generale" — keeps the site uniform by
// default until the admin picks a different color for that one section.
export const sectionBgColor = (settings, key) =>
  (settings?.section_colors && settings.section_colors[key]) || "var(--lv-bg,#060A14)";
